export const isActuallyNaN = string => isNaN(parseInt(string));